import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const fRoute = createRoute({
    path: "/facility",
    name: "menu.facility",
    icon: "business",
    accCode: "fasilitas",
});

export const fCategoryRoute = createRoute({
    path: `${fRoute.path}/category`,
    name: "facility_category.",
    accCode: "fasilitas_kategori_fasilitas",
    parentCode: fRoute.accCode,
});

export const fTransListRoute = createRoute({
    path: `${fRoute.path}/trans-list`,
    name: "facility_list.",
    accCode: "fasilitas_daftar_permohonan",
    parentCode: fRoute.accCode,
});

export const fMasterRoute = createRoute({
    path: `${fRoute.path}/master`,
    name: "facility_master.",
    accCode: "fasilitas_daftar_fasilitas",
    parentCode: fRoute.accCode,
});

export const fMasterCreateRoute = createRoute({
    path: `${fMasterRoute.path}/create`,
    name: "facility_master.add",
    accCode: "fasilitas_daftar_fasilitas",
    action: "create",
    redirectTo: fMasterRoute.path,
    parentCode: fRoute.accCode,
});

export const fMasterEditRoute = createRoute({
    path: `${fMasterRoute.path}/edit`,
    name: "facility_master.edit",
    accCode: "fasilitas_daftar_fasilitas",
    action: "edit",
    redirectTo: fMasterRoute.path,
    parentCode: fRoute.accCode,
});

export const fMasterUploadRoute = createRoute({
    path: `${fMasterRoute.path}/upload`,
    name: "facility_master.upload",
    accCode: "fasilitas_daftar_fasilitas",
    action: "upload",
    parentCode: fRoute.accCode,
    redirectTo: fMasterRoute.path,
});

// component
const Facility = lazy(() => import("../page/facility/Facility"));
const FMaster = lazy(() => import("../page/facility/master/MaterFacility"));
const FMasterForm = lazy(() => import("../page/facility/master/form/MaterFacilityForm"));
const FMasterUpload = lazy(() => import("../page/facility/master/upload/MasterFacilityUpload"));
const FCategory = lazy(() => import("../page/facility/master_category/MasterFacilityCategory"));
const FTransList = lazy(() => import("../page/facility/list/FacilityList"));

export const facilityListRoutes = [
    fMasterRoute, fCategoryRoute, fTransListRoute
]

export const facilityMutationRoute = [
    fMasterCreateRoute, fMasterEditRoute, fMasterUploadRoute
]

export const facilityRoutes = {
    element: <Facility />,
    children: addHandleRoute([
        { ...fMasterRoute, element: <FMaster /> },
        { ...fMasterCreateRoute, element: <FMasterForm /> },
        { ...fMasterEditRoute, element: <FMasterForm /> },
        { ...fMasterUploadRoute, element: <FMasterUpload /> },
        { ...fCategoryRoute, element: <FCategory /> },
        { ...fTransListRoute, element: <FTransList /> },
    ])
};